import { initializeApp } from 'firebase/app';
import { getDatabase, onValue, ref } from 'firebase/database';

const instanceFirebaseApp = () => initializeApp(window.FIREBASE_CONFIG);
const instanceDatabase = () => getDatabase(instanceFirebaseApp());

const connect = (path: string, onChange?: (value: any) => void) => {
  const dbRef = ref(instanceDatabase(), path);
  onValue(dbRef, snapshot => {
    if (!snapshot.exists()) console.log('No data available');

    if (onChange) onChange(snapshot.val());
  });
};

const FirebaseService = { connect };

export default FirebaseService;
